module.exports = __webpack_public_path__ + "static/media/mobileBackground.f70f33c3.svg";